import React from 'react';
import { useExternalAutoForm } from './ExternalAutoForm.hook';
import { Card, FormHeader } from '../';
import { Form } from '../Form/FormExp.component';
import { StyledGridContainer } from './ExternalAutoForm.styles';
import { GridItem } from '@creditasmx-utilities/components';

export const ExternalAutoForm = (): JSX.Element => {
  const { externalAutoId } = useExternalAutoForm();
  return (
    <StyledGridContainer paddingY="80px">
      <GridItem
        column={{
          '3xl-4xl': 4,
          '5xl': 6,
          '6xl': 4,
          '7xl-9xl': 4,
        }}
        columnStart={{ '3xl-5xl': 1, '6xl': 2, '7xl-9xl': 2 }}
      >
        <FormHeader />
        <Card />
      </GridItem>
      <GridItem
        column={{
          '3xl-4xl': 4,
          '5xl': 6,
          '6xl': 5,
          '5xl-9xl': 5,
        }}
        columnStart={{ '3xl-4xl': 5, '5xl-9xl': 7 }}
        gridRow="1/3"
      >
        <Form externalAutoId={externalAutoId} />
      </GridItem>
    </StyledGridContainer>
  );
};
